module.exports = __webpack_public_path__ + "static/media/gift_wrap.7db15b00.png";